import Container from '@/shared/Container';
import Div from '@/shared/Div';
import React from 'react';

function SharedStaticContent(props: any) {
  return (
    <Container>
      <Div
        className="font-primary "
        dangerouslySetInnerHTML={{ __html: props.content }}
        forceRender
      />
    </Container>
  );
}

export default React.memo(SharedStaticContent);
